import { AppNames } from '@app/models/AppNames';
import { Constants } from 'src/app/constants';
import { environment } from 'src/environments/environment';

export function AppInit(): () => Promise<any> {
  return async () => {
    Constants.appConfiguration = environment.appConfig;
    const appName = sessionStorage.getItem('appName');
    if (!appName || appName === AppNames.UNITY_DIRECT) {
      Constants.appConfiguration.clientApplicationId =
        Constants.appConfiguration.UD_ClientApplicationId;
    }
  };
}
